/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Work_0_BadgeInputs */

const en_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rescued full-stack launch`)
};

const ar_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إطلاق متكامل منقذ`)
};

const bn_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উদ্ধার করা ফুল-স্ট্যাক লঞ্চ`)
};

const de_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geretteter Full-Stack-Launch`)
};

const es_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzamiento full-stack rescatado`)
};

const fr_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancement full-stack sauvé`)
};

const pt_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançamento full-stack resgatado`)
};

const zh_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`被拯救的全栈上线`)
};

const tr_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurtarılmış full-stack lansman`)
};

const ru_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спасённый full-stack запуск`)
};

const pl_svc_ai_app_rescue_work_0_badge = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uratowany start full-stack`)
};

/**
* | output |
* | --- |
* | "Rescued full-stack launch" |
*
* @param {Svc_Ai_App_Rescue_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_work_0_badge = /** @type {((inputs?: Svc_Ai_App_Rescue_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_work_0_badge(inputs)
	return en_svc_ai_app_rescue_work_0_badge(inputs)
});
export { svc_ai_app_rescue_work_0_badge as "svc_ai-app-rescue_work_0_badge" }